export const AUTH_ROUTES = {
  LOGIN: '/v2/auth/login',
  REFRESH_TOKEN: '/v2/auth/refresh-token',
  INVITES_VALIDATE: '/v2/invites/validate',
  INVITES_ACCEPT: '/v2/invites/accept',
} as const;
